import { createPresignedUrlGenerator } from '#object-store/s3';
import { ObjectStoreCredentialsKind } from '#object-store/types';
const DEFAULT_EXPIRES_IN_SECONDS = 7 * 24 * 60 * 60; // 1 week
export class PresignedUrlHelper {
    tupleWasm;
    adminCrypto;
    expiresInSeconds = DEFAULT_EXPIRES_IN_SECONDS;
    constructor(tupleWasm, adminCrypto) {
        this.tupleWasm = tupleWasm;
        this.adminCrypto = adminCrypto;
    }
    setExpiresInSeconds(value) {
        this.expiresInSeconds = value;
    }
    async generatePresignedUrl(objectId, dataStore, metadata) {
        const urlGenerator = await this.createUrlGenerator(dataStore);
        return urlGenerator.generate(objectId, this.expiresInSeconds, metadata);
    }
    async createUrlGenerator(dataStore) {
        const secretKey = await this.decrypt(dataStore.adminEncryptedSecretKey);
        return createPresignedUrlGenerator({
            credentials: {
                kind: ObjectStoreCredentialsKind.IAM,
                accessKey: dataStore.accessKey,
                secretKey,
            },
            bucketName: dataStore.bucketName,
            region: dataStore.region,
            endpointOverride: dataStore.endpointOverride,
            useVirtualAddressing: dataStore.useVirtualAddressing,
            httpScheme: dataStore.httpScheme,
        });
    }
    async decrypt(adminEncryptedSecretKey) {
        const decryptedTuple = await this.adminCrypto.decrypt(adminEncryptedSecretKey);
        return this.tupleWasm.getStringFromTuple(decryptedTuple);
    }
}
